<template>
  <div id="globalCarousel">
    <el-carousel
      :interval="5000"
      arrow="always"
      style="margin: 40px 0 20px 0"
      :height="carouselHeight"
    >
      <el-carousel-item v-for="item in carouselList" :key="item.id">
        <!-- <img style="width: 100%; height: 100%;" :src="item" /> -->
        <div
          class="imageDiv"
          :style="{ 'background-image': `url(${pathConfig.indexImgPath}${item.imgUrl})` }"
        ></div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import elementresizeDetector from 'element-resize-detector'

import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: {
    carouselList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      pathConfig: pathConfig,
      carouselHeight: '0px'
    }
  },
  mounted() {
    let _this = this
    let erd = elementresizeDetector()

    let fatherDiv = document.getElementById('globalCarousel')

    erd.listenTo(fatherDiv, function (element) {
      let currentWidth = element.offsetWidth
      let currentHeight = currentWidth / 3.6 + 'px'

      let imageDivList = document.getElementsByClassName('imageDiv')

      for (let i = 0; i < imageDivList.length; i++) {
        document.getElementsByClassName('imageDiv')[
          i
        ].style.height = currentHeight
      }

      let childDivList = fatherDiv.getElementsByTagName('div')

      for (let i = 0; i < childDivList.length; i++) {
        childDivList[i].style.height = currentHeight
      }

      _this.carouselHeight = currentHeight
    })
  }
}
</script>

<style>
.imageDiv {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/globalCarousel.vue